import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { useScrollReveal } from './hooks/useScrollReveal';
import Navbar from './components/Navbar';
import FocusMenuHero from './components/FocusMenuHero';
import ProjectShowcase from './components/ProjectShowcase';
import Capabilities from './components/Capabilities';
import Leadership from './components/Leadership';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function PortfolioApp() {
  // Activate high-performance scroll triggers
  useScrollReveal();

  return (
    <div className="site-root">
      {/* Crosshair Matrix (+) Ambient Background */}
      <div className="matrix-crosshair-bg" aria-hidden="true"></div>

      <a href="#main-content" className="skip-link">
        Skip to Content / İçeriğe Geç
      </a>

      {/* Neobrutalist Navbar with Monogram W */}
      <Navbar />

      <main id="main-content">
        {/* Interactive Focus Menu & Bracket Console */}
        <FocusMenuHero />
        <ProjectShowcase />
        <Capabilities />
        <Leadership />
        <ContactSection />
      </main>

      {/* Neobrutalist Footer */}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <PortfolioApp />
    </LanguageProvider>
  );
}

export default App;
